import React from "react";
import { Row, Col, ListGroup, ListGroupItem, Badge } from "reactstrap";
import Icon from "@material-ui/core/Icon";
import PerfectScrollbar from "react-perfect-scrollbar";
import axios from "axios";
import conf from "../../conf.json";
import { PulseLoader } from "react-spinners";

class Notification extends React.Component {
  constructor(props){
    super(props)
    this.getNotification = this.getNotification.bind(this)
    this.readNotification = this.readNotification.bind(this)
    
    this.state = {
      dataNotification: [],
      Loading:true
    }
    this.getNotification();
  }
  readNotification(id){
    const params = {
      id:id,
      token: localStorage.getItem("token")
    };
    
    axios
      .put(conf.url + "/notification", params, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        this.state.dataNotification.map(data=>{
          if(data.id === id){
            localStorage.setItem("ct_id",data.ct_id);
            window.location.assign("/tables");
          }
        })
       
        this.getNotification();
      });
   
    this.handleClose();
  }
  getNotification() {
   
    const params = {
      token: localStorage.getItem("token")
    };
    axios
      .post(conf.url + "/notification/get", params, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        let count  = 0;
        res.data.data.map(data=>{
          if(data.read_status === 0)
            count++
        })
        this.setState({
          dataNotification: res.data.data,
          countNotification:count,
          Loading:false
        });
      });
  }

  render() {
    let notifications = [];
    if(this.state.dataNotification.length == 0){
      notifications.push(<div className="mt-auto mb-auto p-2">
      ไม่มีแจ้งเตือน
      </div>)
    }
    for (let i = 0; i < (this.state.dataNotification.length ); i++) {
      notifications.push(
        <ListGroupItem action key={this.state.dataNotification[i].id} onClick={()=>this.readNotification(this.state.dataNotification[i].id)} >
        <Badge
          color="white"
          style={{ marginRight: "5px", borderRadius: "50px" }}
        >
           {this.state.dataNotification[i].read_status === 0 ? (
              <Icon
                style={{
                  paddingTop: "2px",
                  marginRight: "4px",
                  color: "red"
                }}
              >
                error
              </Icon>
            ) : (
              <Icon
                style={{
                  paddingTop: "2px",
                  marginRight: "4px",
                  color: "green"
                }}
              >
                check_circle
              </Icon>
            )}
        </Badge>
        <span dangerouslySetInnerHTML={{__html: this.state.dataNotification[i].text.replace(/(?:\r\n|\r|\n)/g, '<br />')}} />
      </ListGroupItem>
      );
      }
    return (
      <div className="container">
         {this.state.Loading && (
          <PulseLoader sizeUnit={"px"} size={50} color={"#F48F0C"} />
        )}
        <Row>
          <Col xs={12} sm={12} md={12}>
            <Row>
              <Col className="text-left" md="12">
                <h5>การแจ้งเตือนของคุณ</h5>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col>
                <PerfectScrollbar>
                  <ListGroup>
                    {notifications}
                   
                  </ListGroup>
                </PerfectScrollbar>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/views/Notification/Notifications.jsx